import { OverflownText } from 'components/OverflownText'

interface SectionWithContentProps {
  title: string
  content: string
  maxLines?: number
}

export function SectionWithContent({
  title,
  content,
  maxLines = 3,
}: SectionWithContentProps) {
  return (
    <div className="flex flex-col gap-2">
      <div className="text-sm font-medium text-gray-700 capitalize">
        {title}
      </div>
      <div className="bg-white rounded min-h-[56px]">
        <OverflownText
          tooltipText={content}
          maxLines={maxLines}
          className="text-xs font-light text-gray-600"
        >
          {content}
        </OverflownText>
      </div>
    </div>
  )
}
